import { render, staticRenderFns } from "./TheAcknowledgedDoc.vue?vue&type=template&id=cfac0c8e&scoped=true"
import script from "./TheAcknowledgedDoc.vue?vue&type=script&lang=js"
export * from "./TheAcknowledgedDoc.vue?vue&type=script&lang=js"
import style0 from "./TheAcknowledgedDoc.vue?vue&type=style&index=0&id=cfac0c8e&prod&lang=css"
import style1 from "./TheAcknowledgedDoc.vue?vue&type=style&index=1&id=cfac0c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfac0c8e",
  null
  
)

export default component.exports